module.exports = __webpack_public_path__ + "media/images/home/common-banner-6a78e74416faec40313837b62f32c61c.png";